/**
 * Check if likes and super likes should be rendered
 * @param {number} likedCount
 * @param {number} superLikedCount
 * @returns {boolean}
 */
const shouldRenderLikesAndSuperLikesUtil = (likedCount, superLikedCount) =>
  likedCount > 0 || superLikedCount > 0

export default shouldRenderLikesAndSuperLikesUtil
